/**
 * Returns the plural form of a word if the count is not 1.
 */
export var pluralize = function (count, text, plural) {
    if (count === 1) {
        return text;
    }
    if (plural) {
        return plural;
    }
    if (text.endsWith('s')) {
        return "".concat(text, "es");
    }
    return "".concat(text, "s");
};
//# sourceMappingURL=pluralize.js.map